import { render, staticRenderFns } from "./ImportantNote.vue?vue&type=template&id=6ba9db46&scoped=true&"
import script from "./ImportantNote.vue?vue&type=script&lang=js&"
export * from "./ImportantNote.vue?vue&type=script&lang=js&"
import style0 from "./ImportantNote.vue?vue&type=style&index=0&id=6ba9db46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba9db46",
  null
  
)

export default component.exports